import { useEffect } from "react";
import { logout as clearSessionCookies } from "../../common/utils";
import Cookies from "js-cookie";

const Logout = () => {
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    clearSessionCookies();

    const programa_login = Cookies.get("p_login");
    Cookies.remove("p_login", { path: "/" });

    if (programa_login) {
      window.location.href = `/login/?p=${programa_login}`;
    } else {
      window.location.href = "/login";
    }
  }, []);

  return null;
};

export default Logout;
